import { gql } from '../../../apollo/__generated__';

export const UPDATE_BEDROOM = gql(`
  mutation UpdateBedroom($updateBedroomInput: UpdateBedroomInput!) {
    updateBedroom(updateBedroomInput: $updateBedroomInput) {
      id
      floor
      doorNumber
      maxUsers
    }
  }
`);
